__turbopack_context__.v({
  "className": "geist_4011473a-module__Pyf6tq__className",
  "variable": "geist_4011473a-module__Pyf6tq__variable",
});
